import QuickAccess from './QuickAccess';

export default QuickAccess;
